import * as m from "../../es2015/plugins/regression";
window.am4plugins_regression = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/regression.js
// module id = null
// module chunks = 